module.exports = __webpack_public_path__ + "media/images/vp/samples/19-c683b44be5ce35843fcb2e77f14ccd80.jpg";